module.exports = __webpack_public_path__ + "img/time.8c8daa03.svg";